import { I18n } from '@/services/i18n';

type Message = {
  header: string;
};

const messages: I18n<Message> = {
  en: {
    header: 'Subscription has been activated!',
  },
  es: {
    header: '¡La suscripción ha sido activada!',
  },
  de: {
    header: 'Das Abonnement wurde aktiviert!',
  },
};

export { messages };
